import { render } from "./user_register.vue?vue&type=template&id=f3c9f5a2"
import script from "./user_register.vue?vue&type=script&lang=js"
export * from "./user_register.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/contragent/user/register/user_register.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f3c9f5a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f3c9f5a2', __exports__)) {
    console.log('reload')
    api.reload('f3c9f5a2', __exports__)
  }
  
  module.hot.accept("./user_register.vue?vue&type=template&id=f3c9f5a2", () => {
    console.log('re-render')
    api.rerender('f3c9f5a2', render)
  })

}


export default __exports__